<template>
    <div>
        <div class="search-box">
            <p>课程名：</p>
            <a-input class="input-box" v-model="searchFrom.courseName" />
            <a-button type="primary" icon="search" @click="fetch">搜索</a-button>
            <a-button type="primary" icon="plus" class="right-btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
        </div>
        <div class="operation-box">
            <!-- <a-button type="primary" v-if="permissions.indexOf('undergraduate:culture:achievements:add')>-1" icon="plus" class="btn" @click="$router.push('/admin/undergraduate/research/achievements/info?type=add')">新增</a-button> -->
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() :remove(selectedRowKeys[0])">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('undergraduate:culture:classroom:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :$refs.info.showDrawer('编辑',selectedRow)"
                v-if="permissions.indexOf('undergraduate:culture:classroom:edit')>-1">
                 修改
            </a-button>
        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            <!-- <template slot="id" slot-scope="text,res">
                <a class="action-btn" @click="$router.push('/admin/undergraduate/culture/syllabus?courseName='+res.courseName+'&courseCode='+res.courseCode)">课程大纲</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$refs.info.showDrawer('编辑',res)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template> -->
        </a-table>
        <info ref="info"></info>
    </div>
</template>
<script>
    import { list,del } from '@/baseAPI/undergraduate/culture/courseMould'
    import Info from './modules/courseMouldInfo'
    import { selectedCheck } from '@/baseAPI/util'

    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
            align:'center',
            width:100,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '课程名',
            dataIndex: 'courseName',
        },
        {
            title: '课程号',
            dataIndex: 'courseCode',
            align:'center'
        },
        {
            title: '学分',
            dataIndex: 'courseCredit',
            align:'center'
        },

    ];
    export default {
        name: 'teacher',
        components: {
            Info
        },
        data () {
            return {
                selectedRowKeys: [],
                permissions:[],
                columns,
                data:[],
                loading: false,
                lastTime:'',
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    courseName:'',
                    semesterCode:'',
                },
                xqArr:[],
                selectedRow:{}
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.fetch()
        },
        methods:{
            selectedCheck(){
                selectedCheck()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.selectedRow=record
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            // handleTableChange(pagination){
            //     this.selectedRowKeys=[];
            //     const pager = { ...this.pagination };
            //     pager.current = pagination.current;
            //     this.pagination = pager;
            //     this.fetch();
            // },
            fetch() {
                this.loading = true;
                list(this.searchFrom).then(res=>{
                    this.data = res.data;
                    this.loading = false;
                })
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除课程模板成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #aaa;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>
